import { useEffect, useRef, useState } from 'react';
import JoditEditorProper from 'jodit-react';

import 'jodit/build/jodit.min.css';

interface IProps {
    value: any,
    config: any,
    onChange: any,
    onBlur: any,
    tabIndex?: number,
    name?: string,
    setFocus?: boolean
}

const JoditEditor = (props: IProps) => {
    const editor = useRef(null);
    const [content, setContent] = useState('');

    const joditWrapperHandleOnBlur = (_: React.FocusEvent<HTMLDivElement>) => {
        // get the code editor value
        const editorValue = editor.current.value;

        // run the change function
        handleEditorChange(editorValue);
    };

    const handleEditorChange = (value: string) => {
        // if the value is the same, don't bother
        if (content === value) return;

        // DO SOMETHING WITH CHANGED VALUE HERE
        // ...

        setContent(value);

        if (props.onChange) {
            props.onChange(value);
        }
    };

    useEffect(() => {
        if (props.value != content) {
            setContent(props.value);
        }
    }, [props.value]);

    return (
        <div onBlur={joditWrapperHandleOnBlur}>
            <JoditEditorProper
                ref={editor}
                value={content}
                config={props.config}
                onBlur={handleEditorChange}
            // onChange={onChange}
            />
        </div>
    );
}

export default JoditEditor;